import { render } from "./FigureComp.vue?vue&type=template&id=809a7566&scoped=true"
import script from "./FigureComp.vue?vue&type=script&lang=js"
export * from "./FigureComp.vue?vue&type=script&lang=js"

import "./FigureComp.vue?vue&type=style&index=0&id=809a7566&lang=scss&scoped=true"

import exportComponent from "/Users/matteomelillo/Dev/wpHeadless/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-809a7566"]])

export default __exports__